export default __webpack_public_path__ + "images/WinterCompanyOnboardingBackground.web.png";